export const getErrorMessage = (error: any) => {
  console.log({ error });
  if (error === undefined || !error.status) return "Error!";
  if (
    error.status === 403 ||
    error.status === "403" ||
    error.response.status === 403 ||
    error.response.status === "403" ||
    error.code === "auth/invalid-custom-token" ||
    error.response?.data?.error?.code === "auth/invalid-custom-token"
  ) {
    localStorage.removeItem("token");
    setInterval(() => {
      window.location.replace("/login");
    }, 2000);
    return "กรุณาเข้าสู่ระบบใหม่อีกครั้ง";
  }
  return (
    error.response?.data?.error?.message ||
    error.response?.data?.error?.code ||
    error.response?.data?.message ||
    error.message ||
    error
  );
};

export const imageError = (e: any, IMAGE_ID?: "PROFILE" | "DEFAULT") => {
  e.target.onerror = null;
  e.target.src =
    IMAGE_ID === "PROFILE"
      ? "https://firebasestorage.googleapis.com/v0/b/pettinee-prodz.appspot.com/o/default%2FProfile_Default.jpg?alt=media&token=4b41be68-05cd-49de-8a62-06845fc36afe"
      : "https://firebasestorage.googleapis.com/v0/b/pettinee-prodz.appspot.com/o/default%2Fimage-error.png?alt=media&token=42a3970b-51bf-43b4-854e-516c68d08ab2";
};
